export const waitingScreenInitialState = {
  visible: false,
  waitingMessage: 'firstMessage',
  journeyCompleted: false,
};

export const waitingScreenReducer = (state, action) => {
  switch (action.type) {
    case 'SET_WAITING_SCREEN_VISIBLE':
      return {
        ...state,
        visible: action.payload,
      };
    case 'SHOW_SECOND_WAITING_MESSAGE':
      return { ...state, waitingMessage: 'secondMessage' };
    case 'SHOW_THIRD_WAITING_MESSAGE':
      return { ...state, waitingMessage: 'thirdMessage' };
    case 'JOURNEY_COMPLETED':
      return { ...state, journeyCompleted: true };
    default:
      return state;
  }
};
